import script from "./RedeemSuccessPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./RedeemSuccessPopup.vue?vue&type=script&setup=true&lang=js"

import "./RedeemSuccessPopup.vue?vue&type=style&index=0&id=725c9094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-725c9094"]])

export default __exports__